import { State } from "country-state-city";
import type { LocationComboboxOption } from "./location-combobox";

// `country-state-city` returns ISO 3166-2 subdivision codes — the same code
// space Vercel's edge geo headers report — so prefilled and manually selected
// regions share one representation. Shared by the profile location picker and
// the contact modal's country/state fields.
export function getStateOptions(
	country: string | null,
): LocationComboboxOption[] {
	if (!country) {
		return [];
	}
	return State.getStatesOfCountry(country)
		.map((s) => ({ id: s.isoCode, label: s.name }))
		.sort((a, b) => a.label.localeCompare(b.label));
}
